/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { WallItemARElementFromJSON, WallItemARElementToJSON, } from './';
export function WallItemStreemshotRevisionFromJSON(json) {
    return WallItemStreemshotRevisionFromJSONTyped(json, false);
}
export function WallItemStreemshotRevisionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'downloadUrl': !exists(json, 'download_url') ? undefined : json['download_url'],
        'arElements': !exists(json, 'ar_elements') ? undefined : (json['ar_elements'].map(WallItemARElementFromJSON)),
        'storageUrl': !exists(json, 'storage_url') ? undefined : json['storage_url'],
        'streemshotId': !exists(json, 'streemshot_id') ? undefined : json['streemshot_id'],
        'edited': !exists(json, 'edited') ? undefined : json['edited'],
    };
}
export function WallItemStreemshotRevisionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'download_url': value.downloadUrl,
        'ar_elements': value.arElements === undefined ? undefined : (value.arElements.map(WallItemARElementToJSON)),
        'storage_url': value.storageUrl,
        'streemshot_id': value.streemshotId,
        'edited': value.edited,
    };
}
//# sourceMappingURL=WallItemStreemshotRevision.js.map